import { ShoppingBag, X } from 'lucide-react'

interface CartHeaderProps {
  onClose: () => void
}

export function CartHeader({ onClose }: CartHeaderProps) {
  return (
    <div className="flex h-24 flex-col items-center justify-center bg-white">
      <div className="relative flex w-full items-center justify-between px-4 sm:px-8">
        <div className="inline-flex items-center gap-2.5">
          <ShoppingBag className="h-7 w-7 text-primary-800" />
          <div className="text-lg font-semibold text-primary-800">Carrinho</div>
        </div>

        <button
          onClick={onClose}
          className="flex h-6 w-6 items-center justify-center rounded border-none outline-none focus:outline-none focus:ring-2 focus:ring-[#6B7B3C] focus:ring-offset-1">
          <X className="h-4 w-4 text-neutral-600" />
        </button>
      </div>

      <div className="w-full border-b border-secondary-200" />
    </div>
  )
}
